import { Dispatch, RootState } from 'shared/state';
import { connect } from 'react-redux';
import NavWidget from './NavWidget';
import { changeWidgetVisible, selectSite } from 'shared/state/ducks/sites';
import { Config } from './types';
import { selectUser } from 'shared/state/misc/oidc';

export interface NavWidgetContainerProps {
  siteId: number;
  editing?: boolean;
  isPreview?: boolean;
  widgetState: Widget<Config>;
}

const mapStateToProps = (
  state: RootState,
  ownProps: NavWidgetContainerProps
) => ({
  user: selectUser()(state),
  published: state.published,
  site: selectSite(ownProps.siteId)(state),
  ...ownProps,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  changeWidgetVisible: (
    siteId: number,
    pageId: number,
    parentWidgetId: string,
    widgetId: string,
    visible: boolean
  ) => {
    dispatch(
      changeWidgetVisible(siteId, pageId, parentWidgetId, widgetId, visible)
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavWidget);
